<ng-container *transloco="let t" class="container">
  <div class="{{cssClass ? cssClass : ''}}">
    @if ((label || translatedLabel) && labelIsVisible) {
      <label for="{{formId ? formId : formControlName}}">
        <p class="regular trim-text d-inline">{{ translatedLabel ?? t(label!) }}</p>
        @if (control.errors?.['required']) {
          <p class="regular d-inline ps-1"><small>*</small></p>
        }
      </label>
    }
    @if (type === 'text') {
      <input type="{{type}}" id="{{formId ? formId : formControlName}}" class="form-control"
             autocomplete="{{autocomplete ? autocomplete : 'on'}}" name="{{formControlName}}" [formControl]="control"
             [placeholder]="translatedPlaceholder ? translatedPlaceholder : placeholder ? t(placeholder) : t(label!)"
             [readonly]="readonly" [ngStyle]="{
        'border-top-right-radius': borderRadiusTopRight || '4px',
        'border-bottom-right-radius': borderRadiusBottomRight || '4px',
        'background-color': backgroundColor || 'transparent',
        'border-color': borderColor || 'var(--input-border-color)'
      }"/>
    }
    @if (type === 'password') {
      <input type="{{type}}" id="{{formId ? formId : formControlName}}" class="form-control" name="{{formControlName}}"
             [formControl]="control"
             [placeholder]="translatedPlaceholder ? translatedPlaceholder : placeholder ? t(placeholder) : t(label!)"
             [readonly]="readonly"/>
    }
    @if (type === 'number') {
      <input type="{{type}}" id="{{formId ? formId : formControlName}}" class="form-control"
             autocomplete="{{autocomplete ? autocomplete : 'on'}}" name="{{formControlName}}" [formControl]="control"
             [placeholder]="translatedPlaceholder ? translatedPlaceholder: placeholder ? t(placeholder) : t(label!)"
             [min]="min" [max]="max" [readonly]="readonly"/>
    }
    @if (type === 'decimal') {
      <input type="text" name="{{formControlName}}" [formControl]="control" id="{{formId ? formId : formControlName}}"
             class="form-control"
             [placeholder]="translatedPlaceholder ? translatedPlaceholder : placeholder ? t(placeholder) : t(label!)"
             numberFormatter [decimalPlaces]="decimalPlaces ?? 2" [readonly]="readonly"/>
    }
    @if (control.touched && !hideErrorMessage) {
      @for (errorMessage of control.errors | errorMessages:formControlName;track errorMessage) {
        <div class="errorMes pt-1">
          {{ errorMessage }}
        </div>
      }
    }
  </div>
</ng-container>
